// extracted by mini-css-extract-plugin
export default {"root":"yGtyIQOANLHahYWHkavN","label":"O8xhb4QjXfLoSq2Gi4jx","control":"XaYzWmMxnFBi7W9XEPXB","small":"eI0rRBRmEkbmbr9pjqav"};